import type React from 'react';

import classNames from 'classnames';

import type { AssetsApprovalBySchema } from '@iconik-io/iconik-api/src/services/assets';
import { Icon } from '@iconik-io/uad';

import TooltipTrigger from '../../tooltip_trigger/tooltip_trigger';

import styles from '../asset_approval_status_detailed.module.css';

const SuccessStatuses: React.FC<{
  approvedBy: AssetsApprovalBySchema[];
  approvedByUser: boolean;
}> = ({ approvedBy, approvedByUser }) => {
  const statuses = [];
  if (approvedBy.length > 0) {
    statuses.push(
      <div key="approve-status-content" className={styles.status_content}>
        <TooltipTrigger
          tooltipText={approvedByUser ? 'Approved by you' : 'Approved'}
          placement="bottom"
          key="approve-status"
          componentProps={{
            role: 'status',
            'aria-label': approvedByUser ? 'Approved by you' : 'Approved',
          }}
        >
          <div className={styles.status_icon}>
            <Icon name={approvedByUser ? 'ra_approved_by_me' : 'ra_approved'} />
          </div>
        </TooltipTrigger>
        {approvedBy.length > 1 ? (
          <div className={styles.counter}>{approvedBy.length}</div>
        ) : null}
      </div>,
    );
  }

  if (statuses.length > 0) {
    return (
      <div className={classNames(styles.status_success, styles.status)}>
        {statuses}
      </div>
    );
  }
  return null;
};

export default SuccessStatuses;
